import React from "react";
import { Box } from "@mui/material";
import { logoSrc } from "../brandAssets";

// Icon + "Tracker" wordmark as one lockup. Everything is sized in em from `fontSize`: the icon equals the
// Minder cap height (0.72em) and is lifted 0.1em to sit centred on the capitals rather than on the line box.
export default function BrandLogo({ text, theme = "light", fontSize, sx }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "0.2em", fontSize, ...sx }}>
      <Box
        component="img"
        src={logoSrc(theme)}
        alt=""
        aria-hidden="true"
        sx={{ display: "block", width: "0.72em", height: "0.72em", flexShrink: 0, position: "relative", top: "-0.1em" }}
      />
      <Box
        sx={{
          color: "text.primary",
          fontFamily: '"Minder", sans-serif',
          fontWeight: 400,
          letterSpacing: "0.01em",
        }}
      >
        {text}
      </Box>
    </Box>
  );
}
